import LoadingSpinner from '../assets/LoadingSpinner.svg';

function Loading(){
    return (
        <div className='loading'><img className='spinner' src={LoadingSpinner} alt='Loading' /></div>
    )
}

export default Loading;